<template>
	<div class="styles tabs">
		<a
			v-for="style in styles"
			class="style"
			:key="style.title"
			:class="{active: style.active}"
			@click="activate(style)"
			>{{ style.title }}</a
		>
	</div>
</template>

<script>
export default {
	props: {
		styles: {type: Array, required: true}
	},
	methods: {
		activate(style) {
			this.styles.forEach((x) => (x.active = false));
			style.active = true;

			goatevent({
				path: location.host + `-single-style`,
				title: `single style`,
				event: true
			});
		}
	}
};
</script>

<style lang="scss" scoped></style>
